module.exports = __webpack_public_path__ + "media/images/balneo-60d7f159fec605c5c5efa30ae2dab096.jpg";